import styled from 'styled-components';
interface Props {}

export const PopupCustomizationStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .card-table {
    position: relative;
    .Polaris-IndexFilters-Container {
      padding-right: 2.75rem;
      padding-left: 0.25rem;
    }
    .btn-delete {
      position: absolute;
      top: 0.5rem;
      right: 1rem;
      z-index: 10;
      display: flex;
      gap: 0.5rem;
    }
  }
`;
